import { render, staticRenderFns } from "./userDistribution.vue?vue&type=template&id=5506226e&"
import script from "./userDistribution.vue?vue&type=script&lang=js&"
export * from "./userDistribution.vue?vue&type=script&lang=js&"
import style0 from "./userDistribution.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports